import { Component, OnInit } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { ProfileService } from '../services/profile.service';
import { CompanyDetailsService } from '../services/company-details.service';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { SwPush, SwUpdate } from '@angular/service-worker';
import { NotificationsService } from '../services/notifications.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LogService } from '../services/log.service';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  public company;
  public flag = false;
  public isFullyLoaded;
  showPassword = false;
  readonly VAPID_PUBLIC_KEY = "BIrxCacdxpxiM2l5GWMDEsgEAfJA8lmZP7p7n9cQW6EfibpgBFiPz3PEPv2_AXUWyFE8fXEt2BqxhaAYgv3T_70";
  constructor (private _AuthService: AuthService,
    private _ProfileService: ProfileService,
    private CompanyDetailsService: CompanyDetailsService,
    private http: HttpClient, private _Router: Router, private swPush: SwPush,
    private _notificationsService: NotificationsService, public snackBar: MatSnackBar, public log: LogService) {

  }

  ngOnInit () {
    this.isFullyLoaded = false;
    this.CompanyDetailsService.getDetails().subscribe(data => {
      this.company = data;
      if (data.system == 'University System') {
        localStorage.setItem("p_system", 'tert');

      } else {
        localStorage.setItem("p_system", 'psec');
      }
      this.isFullyLoaded = true;
    }, () => {
      this.isFullyLoaded = true;
    })

  }

  errorMessagee = "";
  loginHandler (event) {
    // this.errorMessagee = ""
    this.flag = true;
    event.preventDefault();
    const target = event.target;
    const username = target.querySelector('#usr').value;
    const password = target.querySelector('#pass').value;
    this._AuthService.getUserDetails(username, password).subscribe({
      next: (data) => {
        if (data.success) {
          this._Router.navigate(['home']);
          this._AuthService.setLoggedIn(true);
          this.log
            .addLog({
              action: "Log in",
              component: "Log In",
              details: `Logged In`,
            })
            .subscribe((data) => { });

          // this.swPush.requestSubscription({
          //   serverPublicKey : this.VAPID_PUBLIC_KEY
          // }).then(sub => {
          //     let trans = {'username':username, 'sub': sub};
          //     this._notificationsService.saveUserInfo(trans).subscribe(res => {
          //       console.log(res);
          //     })


          // })

        } else if (data.message) {
          this.errorMessagee = data.message
          this.flag = false;
        } else {
          this.flag = false;
          this.errorMessagee = "We couldn't process your request at the moment. Please refresh and try again."

        }
      }, error: (err: any) => {
        this.flag = false;
        this.errorMessagee = "An error occured. Please refresh and try again."
      }
    })


  }

  // showMessages() {

  //   this.swPush.messages
  //     .subscribe(message => {

  //       console.log('[App] Push message received', message);

  //       // let notification = message['notification'];

  //       // console.log(notification);

  //     })

  // }



}
